import OInputField from 'components/reusable/OInputField'
import OMapContainer from 'components/reusable/OMapContainer'
import AuthContext from 'context/AuthContext'
import useToastContext from 'hooks/useToastContext'
import { isEmpty, orderBy, get as __get } from 'lodash'
import React, { startTransition, useContext, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { apiGet, apiPut } from 'utils/apiFetch'
import apiPath from 'utils/apiPath'
import { AREA_BOUND, AREA_REGION, COUNTRY_RESTRICTIONS } from 'utils/constants'
import ErrorMessage from 'components/ErrorMessage'

const AppointmentLocation = ({
  setIsAppointmentLocation,
  item,
  getApprovedAppointments,
  setAddress
}) => {
  const { t } = useTranslation()
  const notification = useToastContext()
  const { config } = useContext(AuthContext)
  const [city, setCity] = useState('')
  const [editProperty] = useState(item?.property)

  const [cities, setCities] = useState([])
  const [communities, setCommunities] = useState([])
  const [subCommunities, setSubCommunities] = useState([])

  const [community, setCommunity] = useState('')
  const [subCommunity, setSubCommunity] = useState('')

  const [markerPosition, setMarkerPosition] = useState(
    AREA_REGION[config.country]
  )
  const [center, setCenter] = useState(AREA_REGION[config.country])

  const [selectedCity, setSelectedCity] = useState('')
  const [selectedCommunity, setSelectedCommunity] = useState('')
  const [selectedSubCommunity, setSelectedSubCommunity] = useState('')
  const {
    register,
    setValue,
    // watch,
    handleSubmit,
    formState: { errors }
  } = useForm({
    mode: 'onChange',
    shouldFocusError: true,
    defaultValues: {
      street: editProperty?.street,
      building: editProperty?.building,
      unitNumber: editProperty?.unitNumber,
      city: editProperty?.city,
      community: editProperty?.community,
      subCommunity: editProperty?.subCommunity
    }
  })
  const addressChanged = address => {
    if (!isEmpty(selectedSubCommunity)) {
      const locObj = subCommunities.find(c => c._id === selectedSubCommunity)
      if (!isEmpty(locObj)) {
        const positionObj = Array.from(
          __get(locObj, 'location.coordinates')
        ).reverse()
        setMarkerPosition({ lat: positionObj[0], lng: positionObj[1] })
        setCenter({ lat: positionObj[0], lng: positionObj[1] })
        setSubCommunity(locObj.name)
      }
    } else if (!isEmpty(selectedCommunity)) {
      const locObj = communities.find(c => c._id === selectedCommunity)
      if (!isEmpty(locObj)) {
        const positionObj = Array.from(
          __get(locObj, 'location.coordinates')
        ).reverse()
        setMarkerPosition({ lat: positionObj[0], lng: positionObj[1] })
        setCenter({ lat: positionObj[0], lng: positionObj[1] })
        setCommunity(locObj.name)
      }
    } else if (!isEmpty(selectedCity)) {
      const locObj = cities.find(c => c._id === selectedCity)
      if (!isEmpty(locObj)) {
        const positionObj = Array.from(
          __get(locObj, 'location.coordinates')
        ).reverse()
        setMarkerPosition({ lat: positionObj[0], lng: positionObj[1] })
        setCenter({ lat: positionObj[0], lng: positionObj[1] })
        setCity(locObj.name)
      }
    }
  }
  const onSubmit = async data => {
    try {
      const payload = {
        ...data,
        isApprovedStatus: 'accepted',
        // address: mapAddress?.formatted_address,

        ...(markerPosition && {
          latitude: markerPosition.lat
        }),
        ...(markerPosition && {
          longitude: markerPosition.lng
        }),
        city,
        community,
        subCommunity
      }
      const path = `${apiPath.approvalAppointmentsStatusChange}/${item?._id}`
      const result = await apiPut(path, payload)
      const resultResponse = result?.data
      if (resultResponse?.success) {
        notification.success(resultResponse.message)
        setAddress(resultResponse?.results)
        getApprovedAppointments()
        setIsAppointmentLocation(false)
      } else {
        notification.error(resultResponse.message)
      }
    } catch (error) {
      console.error('error in get all users list==>>>>', error.message)
    }
  }
  const getCities = async (
    countryName = '',
    ciyId = '',
    communityId = '',
    subCommunityId = ''
  ) => {
    try {
      const payload = {}
      const path = apiPath.citiesListForAddress
      const result = await apiGet(path, payload)
      const records = result?.data?.results
      setCities(records)
      startTransition(() => {
        setValue('cityId', ciyId)
        setSelectedCity(ciyId)
        getCommunities(ciyId, { communityId, subCommunityId })
      })
    } catch (error) {
      console.error('error in get all users list==>>>>', error.message)
    }
  }
  const getCommunities = async (cityId = '', option) => {
    try {
      const payload = { cityId }
      const path = apiPath.communityListByCityId
      const result = await apiGet(path, payload)
      const records = result?.data?.results
      if (result?.data?.success) {
        setCommunities(orderBy(records, ['name'], ['asc']))
        startTransition(() => {
          setValue('communityId', option?.communityId)
          setSelectedCommunity(option?.communityId)
          startTransition(() => {
            getSubCommunities(option?.communityId, {
              subCommunityId: option?.subCommunityId
            })
          })
        })
      } else {
        setSelectedCommunity('')
        setValue('community', '')
        setSelectedSubCommunity('')
        setValue('subCommunity', '')
      }
    } catch (error) {
      console.error('error in get all users list==>>>>', error.message)
    }
  }

  const getSubCommunities = async (communityId = '', option) => {
    try {
      const payload = { communityId: communityId }
      const path = apiPath.subCommunityListByCommunityId
      const result = await apiGet(path, payload)
      const records = result?.data?.results
      if (result?.data?.success) {
        setSubCommunities(orderBy(records, ['name'], ['asc']))
        startTransition(() => {
          setValue('subCommunityId', option?.subCommunityId)
          setSelectedSubCommunity(option?.subCommunityId)
        })
      } else {
        setSelectedCommunity('')
        setValue('community', '')
        setSelectedSubCommunity('')
        setValue('subCommunity', '')
      }
    } catch (error) {
      console.error('error in get all users list==>>>>', error.message)
    }
  }
  const handleCitySelect = e => {
    setSelectedCity(e.target.value)
    setSelectedCommunity('')
    setSelectedSubCommunity('')
    setCommunities([])
    setSubCommunities([])

    getCommunities(e.target.value, {})
  }

  const handleCommunitySelect = e => {
    const communityId = e.target.value
    setSelectedCommunity(communityId)
    getSubCommunities(communityId, { communityId })
  }
  const handleSubCommunitySelect = e => {
    const subCommunityId = e.target.value
    setSelectedSubCommunity(subCommunityId)
    // setSelectedSubCommunity(subCommunityId)
  }

  useEffect(() => {
    if (editProperty?.address) {
      getCities(
        editProperty?.country || 'UAE',
        editProperty?.cityId || '',
        editProperty?.communityId || '',
        editProperty?.subCommunityId || ''
      )
      setValue('communityId', editProperty?.communityId)
      setValue('subCommunityId', editProperty?.subCommunityId)
      setValue('cityId', editProperty?.cityId)
      setCity(editProperty?.city)
      setCommunity(editProperty?.community)
      setSubCommunity(editProperty?.subCommunity)
    }
  }, [])

  useEffect(() => {
    getCities()
    // eslint-disable-next-line
  }, [])
  useEffect(() => {
    addressChanged({ selectedCity, selectedCommunity, selectedSubCommunity })
  }, [selectedCity, selectedCommunity, selectedSubCommunity])
  return (
    <>
      <div className='justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
        <div className='relative w-auto my-6 mx-auto max-w-3xl'>
          <div className='sm:py-4 sm:px-2 py-8 px-7'>
            <div className='border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[762px]'>
              <div className='flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t'>
                <h3 className='text-xl font-semibold'>
                  {t('APPOINTMENT_LOCATION')}
                </h3>
                <button
                  className=' ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none'
                  onClick={() => setIsAppointmentLocation(false)}
                >
                  <span className=' text-[#B8BBBF]  text-4xl ' title='Close'>
                    ×
                  </span>
                </button>
              </div>
              <div className='relative  flex-auto'>
                <div className=' overflow-hidden rounded-lg my-5 w-full'>
                  <OMapContainer
                    addressChanged={addressChanged}
                    options={{
                      AREA_BOUND: AREA_BOUND[config.country], // Sample: { north: 26.245017, south: 22.495708, east: 56.611014, west: 51.498994}
                      AREA_REGION: AREA_REGION[config.country], // Sample: { lat: 23.424076, lng: 53.847818}
                      COUNTRY_RESTRICTIONS:
                        COUNTRY_RESTRICTIONS[config.country], // Sample: "AE"
                      ADDRESS: !isEmpty(editProperty)
                        ? editProperty?.address
                        : '',
                      // ...(!isEmpty(editProperty) &&
                      //   editProperty?.location?.coordinates?.length && {
                      //     ...(editProperty?.location?.coordinates[1] && {
                      //       lat: editProperty?.location?.coordinates[1]
                      //     }),
                      //     ...(editProperty?.location?.coordinates[0] && {
                      //       lng: editProperty?.location?.coordinates[0]
                      //     })
                      //   })
                      markerPosition: markerPosition,
                      center: center
                    }}
                  />
                </div>
                <div className='p-5'>
                  <div className='grid grid-rows-1 grid-cols-3 gap-4'>
                    {/* <div className='mb-3 '>
                      <OSelect
                        wrapperClassName='relative z-0  w-full group'
                        name='city'
                        type='select'
                        options={cities}
                        selected={editProperty?.city ?? ''}
                        defaultValue={t('SELECT_CITY')}
                        register={register('city', {
                          onChange: e => handleCitySelect(e),
                          required: 'Please select city.'
                        })}
                        errors={errors}
                      />
                    </div>
                    <div className='mb-3 '>
                      <OSelect
                        wrapperClassName='relative z-0  w-full group'
                        name='community'
                        type='select'
                        options={communities}
                        selected={editProperty?.community ?? ''}
                        defaultValue={t('SELECT_COMMUNITY')}
                        register={register('community', {
                          onChange: e => handleCommunitySelect(e.target.value),
                          required: 'Select Community'
                        })}
                        errors={errors}
                      />
                    </div>
                    <div className='mb-3 '>
                      <OSelect
                        wrapperClassName='relative z-0  w-full group'
                        name='subCommunity'
                        type='select'
                        options={subCommunities}
                        selected={editProperty?.subCommunity ?? ''}
                        defaultValue={t('SELECT_SUB_COMMUNITY')}
                        register={register('subCommunity', {})}
                      />
                    </div> */}
                    <div className='mb-3 '>
                      <div className='relative z-0  w-full group'>
                        <label
                          htmlFor='cityId'
                          className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'
                        >
                          {t('SELECT_CITY')}
                          <span className='text-red-500'>*</span>
                        </label>

                        <select
                          className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                          value={selectedCity}
                          id='cityId'
                          {...register('cityId', {
                            required: {
                              value: true,
                              message: 'Please select city..'
                            },
                            onChange: e => handleCitySelect(e)
                          })}
                          placeholder=' '
                        >
                          <option value=''>{t('SELECT_CITY')}</option>
                          {cities.map(newCity => (
                            <option key={newCity?._id} value={newCity?._id}>
                              {newCity?.name}
                            </option>
                          ))}
                        </select>
                        <ErrorMessage message={errors?.cityId?.message} />
                      </div>
                    </div>

                    <div className='mb-3 '>
                      <div className='relative z-0  w-full group'>
                        <label
                          htmlFor='communityId'
                          className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'
                        >
                          {t('SELECT_COMMUNITY')}
                          <span className='text-red-500'>*</span>
                        </label>

                        <select
                          className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                          value={selectedCommunity}
                          id='communityId'
                          {...register('communityId', {
                            required: {
                              value: true,
                              message: 'Select Community.'
                            },
                            onChange: e => handleCommunitySelect(e)
                          })}
                          placeholder=' '
                        >
                          <option value=''>{t('SELECT_COMMUNITY')}</option>
                          {communities.map(newCommunity => (
                            <option
                              key={newCommunity?._id}
                              value={newCommunity?._id}
                            >
                              {newCommunity?.name}
                            </option>
                          ))}
                        </select>
                        <ErrorMessage message={errors?.communityId?.message} />
                      </div>
                    </div>

                    <div className='mb-3 '>
                      <div className='relative z-0  w-full group'>
                        <label
                          htmlFor='subCommunityId'
                          className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'
                        >
                          {t('SELECT_SUB_COMMUNITY')}
                          {/* <span className='text-red-500'>*</span> */}
                        </label>

                        <select
                          className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                          value={selectedSubCommunity}
                          id='subCommunityId'
                          {...register('subCommunityId', {
                            onChange: e => handleSubCommunitySelect(e)
                          })}
                          placeholder=' '
                        >
                          <option value=''>{t('SELECT_SUB_COMMUNITY')}</option>
                          {subCommunities.map(newSubCommunity => (
                            <option
                              key={newSubCommunity?._id}
                              value={newSubCommunity?._id}
                            >
                              {newSubCommunity?.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className='mb-3'>
                      <label className='block'>
                        <OInputField
                          wrapperClassName='relative z-0   w-full group'
                          name='building'
                          inputLabel={
                            <>
                              {t('BUILDING')}
                              {/* <span className='text-red-500'>*</span> */}
                            </>
                          }
                          type='text'
                          register={register(
                            'building'
                            // formValidation.building
                          )}
                          errors={errors}
                        />
                      </label>
                    </div>
                    <div className='mb-3'>
                      <label className='block'>
                        <OInputField
                          wrapperClassName='relative z-0   w-full group'
                          name='unitNumber'
                          inputLabel={
                            <>
                              {t('UNIT_NUMBER')}
                              {/* <span className='text-red-500'>*</span> */}
                            </>
                          }
                          type='text'
                          register={register(
                            'unitNumber'
                            // formValidation.unitNumber
                          )}
                          errors={errors}
                        />
                      </label>
                    </div>
                    <div className='mb-3'>
                      <label className='block'>
                        <OInputField
                          wrapperClassName='relative z-0   w-full group'
                          name='street'
                          inputLabel={
                            <>
                              {t('STREET')}
                              {/* <span className='text-red-500'>*</span> */}
                            </>
                          }
                          type='text'
                          register={register('street')}
                          errors={errors}
                        />
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className='flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b'>
                <button
                  className='bg-[#8FC150] text-white active:bg-emerald-600 font-normal text-sm  px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-5  ease-linear transition-all duration-150'
                  onClick={handleSubmit(onSubmit)}
                >
                  {t('O_SUBMIT')}
                </button>
                <button
                  className='text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150'
                  type='button'
                  onClick={() => setIsAppointmentLocation(false)}
                >
                  {t('O_CLOSE')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='opacity-25 fixed inset-0 z-40 bg-black' />
    </>
  )
}

export default AppointmentLocation
